const count = 100;
export const STATIC_DATA = {data:{data:[], success: "Comm Details fetched successfully.",
total: count,
total_unread: count/4}}
create_data();



function create_data()
{   
  for(let i=0; i< count; i++)
  {
    STATIC_DATA.data.data.push({
                "id": `${Math.random()* 1000}`,
                "description": "11:53 am Wednesday, 27 July 2022 (IST) Time in Chandigarh",
                "sender": `Static Candidate ${i}`,
                "when": `${Math.random()* 1000} minutes ago`,
                "read": `${Math.random() < 0.5}`,
                "href": null,
                "comm_detail_id": `${Math.random()* 1000}`
            })
  }
}